import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getRules=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_RULES_START
    })
    const options={
        url:`${api}/rules`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_RULES_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_RULES_FAIL,
                payload:getMessage(error)
            }))
}